export default {
	appEnv: 'development',
	apiUrl: 'http://localhost:3001',
	maxFile: 50,
	chatbotUrl: 'http://localhost:3004',
	contentApiUrl: 'http://localhost:3002',
	chatbotScriptUrl: '',
	sentryDsn: 'https://38f8c51f13b947468504f4c4d4fac5ef@o4505295141535744.ingest.sentry.io/4505295149334528',
	version: '__VERSION__',
	googleRecaptchaSiteKey: '6LfLrr0qAAAAAA2n8CEOJNeFGnRLPFqUXC94b9EQ'
}
